/**
 * Whether what was typed is `name` exactly, ignoring surrounding whitespace,
 * gating a destructive delete the way S3 gates bucket deletion. Case-sensitive:
 * a device ID or an agent's name is chosen by the user and may carry mixed
 * case, so a loose match would let the user confirm a resource other than the
 * one they are looking at.
 */
export function isDeleteConfirmed(typed: string, name: string): boolean {
  return typed.trim() === name;
}
